export default __webpack_public_path__ + "img/homepage-desktop.1a4dc43e.svg";